import { render, staticRenderFns } from "./BindLicensesHeader.vue?vue&type=template&id=b7bebd6e&scoped=true&"
import script from "./BindLicensesHeader.vue?vue&type=script&lang=ts&"
export * from "./BindLicensesHeader.vue?vue&type=script&lang=ts&"
import style0 from "./BindLicensesHeader.vue?vue&type=style&index=0&id=b7bebd6e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7bebd6e",
  null
  
)

export default component.exports